/* eslint no-undef: "off"*/
/* global jQuery, padding */
import React, { useEffect, useState, useContext, useRef, useCallback } from 'react';
import $ from 'jquery';
import { Link, useLocation } from 'react-router-dom';
import { ViewerAction } from '../../actions/viewer';
import { useDispatch, useSelector } from 'react-redux';
import '../styles/viewer.css';
import { ViewerFileStorage } from '../../actions/viewerFileStorage';
import boobyR from '../../images/Logo_removebg.32d760f492fb021859c6_fit.png';
import { LinkEntryAction } from '../../actions/LinkEntryAction';
import { DownloadFilesAction } from '../../actions/downloadFiles';
import { PrintPDFFiles } from '../../actions/printPDFFileAction';
import { SendReportEmail } from '../../actions/sendReportEmail';
import Spinner from 'react-bootstrap/Spinner';
import { House, Eye, Presentation, Printer, Download, Megaphone, Minus, Plus } from "@phosphor-icons/react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SplashScreen from './splashScreen';
import WestIcon from '@mui/icons-material/West';
import EastIcon from '@mui/icons-material/East';
export default function Viewer() {
    const location = useLocation();

    const { id } = location.state !== null ? location.state : { id: parseInt(window.location.pathname.split("/").slice(-1)[0]) };
    const { type } = location.state !== null ? location.state : { type: window.location.pathname.split("/")[2] };
    const { viewkey } = location.state !== null ? location.state : { viewkey: window.location.pathname.split("/").slice(-1)[0] };
    const [loading, setLoading] = useState(false);

    const [test, setTest] = useState(0);
    const testRef = useRef(test);
    useEffect(() => {
        testRef.current = test;
    }, [test])




    const dispatch = useDispatch();
    const viewerFileStorageReducer = useSelector(state => state.viewerFileStorageReducer);
    const LinkEntryReducer = useSelector(state => state.LinkEntryReducer);
    const [streamFlag, setStreamFlag] = useState(false);
    const [pagefind, setPageFind] = useState(null);
    const viewerReducer = useSelector(state => state.viewerReducer);
    const [totalPage, setTotalPage] = useState(1);
    var [pages, setPages] = useState(1);
    const PagesRef = useRef(1);
    const [isAllowedDownload, setIsAllowedDownload] = useState(true);
    const IndexReducer = useSelector(state => state.IndexReducer);
    const [permission, setPermission] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    const [tempVal, setTempVal] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const cpRef = useRef(currentPage);
    const ratioRef = useRef(1);
    useEffect(() => {
        cpRef.current = currentPage;
    }, [currentPage]);


    useEffect(() => {

        document.getElementsByTagName("body")[0].classList.add("hidetopbar");

        return () => {

            document.getElementsByTagName("body")[0].classList.remove("hidetopbar");

        }

    }, []);


    /*var _extends = Object.assign ||
        function (a) {
            for (var b, c = 1; c < arguments.length; c++)
                for (var d in b = arguments[c], b)
                    Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
            return a
        },
        SwipeListener = function (a, b) {
            if (a) {
                'undefined' != typeof window && function () {
                    function a(a, b) {
                        b = b || { bubbles: !1, cancelable: !1, detail: void 0 };
                        var c = document.createEvent('CustomEvent');
                        return c.initCustomEvent(a, b.bubbles, b.cancelable, b.detail), c
                    }
                    return 'function' != typeof window.CustomEvent && void (a.prototype = window.Event.prototype, window.CustomEvent = a)
                }();
                b || (b = {}),
                    b = _extends({},{
                            minHorizontal: 10,
                            minVertical: 10,
                            deltaHorizontal: 3,
                            deltaVertical: 5,
                            preventScroll: !1,
                            lockAxis: !0,
                            touch: !0,
                            mouse: !0
                        }, b);
                var c = [],
                    d = !1,
                    e = function () {
                        d = !0
                    },
                    f = function (a) {
                        d = !1, h(a)
                    },
                    g = function (a) {
                        d && (a.changedTouches = [{ clientX: a.clientX, clientY: a.clientY }], i(a))
                    };
                b.mouse && (a.addEventListener('mousedown', e), a.addEventListener('mouseup', f), a.addEventListener('mousemove', g));
                var h = function (d) {
                    var e = Math.abs, f = Math.max, g = Math.min;
                    if (c.length) {
                        for (var h = 'function' == typeof TouchEvent && d instanceof TouchEvent, j = [], k = [], l = { top: !1, right: !1, bottom: !1, left: !1 }, m = 0; m < c.length; m++)
                            j.push(c[m].x),
                                k.push(c[m].y);
                        var i = j[0],
                            n = j[j.length - 1],
                            o = k[0], p = k[k.length - 1],
                            q = { x: [i, n], y: [o, p] };
                        if (1 < c.length) {
                            var r = { detail: _extends({ touch: h, target: d.target }, q) },
                                s = new CustomEvent('swiperelease', r);
                            a.dispatchEvent(s)
                        }
                        var t = j[0] - j[j.length - 1],
                            u = 'none';
                        u = 0 < t ? 'left' : 'right';
                        var v, w = g.apply(Math, j), x = f.apply(Math, j);
                        if (e(t) >= b.minHorizontal && ('left' == u ? (v = e(w - j[j.length - 1]), v <= b.deltaHorizontal && (l.left = !0)) : 'right' == u ? (v = e(x - j[j.length - 1]), v <= b.deltaHorizontal && (l.right = !0)) : void 0),
                            t = k[0] - k[k.length - 1], u = 'none', u = 0 < t ? 'top' : 'bottom', w = g.apply(Math, k), x = f.apply(Math, k), e(t) >= b.minVertical && ('top' == u ? (v = e(w - k[k.length - 1]), v <= b.deltaVertical && (l.top = !0)) : 'bottom' == u ?
                                (v = e(x - k[k.length - 1]), v <= b.deltaVertical && (l.bottom = !0)) : void 0), (c = [], l.top || l.right || l.bottom || l.left)) {
                                    b.lockAxis && ((l.left || l.right) && e(i - n) > e(o - p) ? l.top = l.bottom = !1 : (l.top || l.bottom) && e(i - n) < e(o - p) && (l.left = l.right = !1));
                            var y = { detail: _extends({ directions: l, touch: h, target: d.target }, q) },
                                z = new CustomEvent('swipe', y);
                            a.dispatchEvent(z)
                        } else {
                            var A = new CustomEvent('swipecancel', { detail: _extends({ touch: h, target: d.target }, q) });
                            a.dispatchEvent(A)
                        }
                    }
                },
                    i = function (d) {
                        var e = d.changedTouches[0];
                        if (c.push({ x: e.clientX, y: e.clientY }), 1 < c.length) {
                            var f = c[0].x, g = c[c.length - 1].x, h = c[0].y, i = c[c.length - 1].y,
                                j = { detail: { x: [f, g], y: [h, i], touch: 'function' == typeof TouchEvent && d instanceof TouchEvent, target: d.target } },
                                k = new CustomEvent('swiping', j), l = !0 === b.preventScroll || 'function' == typeof b.preventScroll && b.preventScroll(k);
                            l && d.preventDefault(), a.dispatchEvent(k)
                        }
                    },
                    j = !1;
                try {
                    var k = Object.defineProperty({}, 'passive', { get: function () { j = { passive: !b.preventScroll } } });
                    window.addEventListener('testPassive', null, k),
                        window.removeEventListener('testPassive', null, k)
                } catch (a) {
                }
                return b.touch && (a.addEventListener('touchmove', i, j), a.addEventListener('touchend', h)), {
                    off: function () {
                        a.removeEventListener('touchmove', i, j), a.removeEventListener('touchend', h), a.removeEventListener('mousedown', e), a.removeEventListener('mouseup', f), a.removeEventListener('mousemove', g)
                    }
                }
            }
        };
    'undefined' != typeof module && 'undefined' != typeof module.exports ? (module.exports = SwipeListener, module.exports.default = SwipeListener) : 'function' == typeof define && define.amd ? define([], function () { return SwipeListener }) : window.SwipeListener = SwipeListener;

    */
    /*useEffect(() => {

        const container = document.getElementById("sw");
        var listener = SwipeListener(container);

        container.addEventListener('swipe', function (e) {

            var d = e.detail.directions;

            if (d.top) {
                if (d.right) {
                    setMessage('Swiped top-right.');
                } else if (d.left) {
                    setMessage('Swiped top-left.');
                } else {
                    setMessage('Swiped top.');
                }
            } else if (d.bottom) {
                if (d.right) {
                    setMessage('Swiped bottom-right.');
                } else if (d.left) {
                    setMessage('Swiped bottom-left.');
                } else {
                    setMessage('Swiped bottom.');
                }
            } else {
                if (d.right) {
                    setMessage('Swiped right.');
                    if (currentPage > 0)
                        ToPage(currentPage - 1)
                } else if (d.left) {
                    setMessage('Swiped left.');
                    if (currentPage < pages - 1)
                        ToPage(currentPage + 1)
                }
            }
        });
    },[])
    */
    useEffect(() => {

        let touchstartX = 0
        let touchendX = 0


        function checkDirection() {
            if (touchendX < touchstartX) {
                if (cpRef.current < PagesRef.current - 1) {
                    var ctt = cpRef.current + 1;
                    setLoading(false);
                    dispatch(ViewerFileStorage(id, ctt));
                    setCurrentPage(ctt);
                    setPageFind(String(ctt + 1));
                }

                //dispatch(ViewerFileStorage(id, currentPage - 1));

            }
            if (touchendX > touchstartX) {
                if (cpRef.current >= 1) {
                    var ctr = cpRef.current - 1;
                    setLoading(false);
                    dispatch(ViewerFileStorage(id, ctr));
                    //dispatch(ViewerFileStorage(id, currentPage - 1));
                    setCurrentPage(ctr);
                    setPageFind(String(ctr + 1));
                }
            }
        }

        document.addEventListener('touchstart', e => {
            touchstartX = e.changedTouches[0].screenX
        })

        document.addEventListener('touchend', e => {
            touchendX = e.changedTouches[0].screenX
            checkDirection()
        })
    }, [])

    window.mobileAndTabletCheck = function () {
        let check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    };

    useEffect(() => {

        if (type && type === "LinkEntry") {
            dispatch(LinkEntryAction(String(viewkey)));
            dispatch(ViewerFileStorage(id, currentPage));
        } else {
            dispatch(ViewerAction(id))
            dispatch(ViewerFileStorage(id, currentPage));
        }
    }, []);

    useEffect(() => {
        var isMobile = mobileAndTabletCheck();
        if (isMobile) {
            $('#scaleSelect')[0].value = "page-fit"
        }
    }, [])

    useEffect(() => {

        if (viewerReducer && viewerReducer !== null && viewerReducer.data && viewerReducer.data.isSuccessful === true) {
            setFlg(true);
            setPageFind('1');
            setTotalPage(viewerReducer.data.data.doc.totalPages);
            setPages(viewerReducer.data.data.doc.totalPages);
            PagesRef.current = viewerReducer.data.data.doc.totalPages;
            setIsAllowedDownload(viewerReducer.data.data.isAllowed);
        }
    }, [viewerReducer])

    useEffect(() => {

        if (LinkEntryReducer && LinkEntryReducer.data && LinkEntryReducer.data.isSuccessful === true) {
            setFlg(true);
            setPageFind('1');
            setTotalPage(LinkEntryReducer.data.data.document.totalPages);
            setPages(LinkEntryReducer.data.data.document.totalPages);
            PagesRef.current = LinkEntryReducer.data.data.document.totalPages;
            setIsAllowedDownload(LinkEntryReducer.data.data.allowDownload);
        }
    }, [LinkEntryReducer])
    useEffect(() => {
        console.log("viewerFileStorageReducer ", currentPage, viewerFileStorageReducer.fetching);
        if (viewerFileStorageReducer.fetching) {

        }
        else if (viewerFileStorageReducer && viewerFileStorageReducer.data) {
            ToPage(currentPage);
        } else if (viewerFileStorageReducer && viewerFileStorageReducer.error) {
            setErrorMessage(viewerFileStorageReducer.error.errors[0]);
            setPermission(false);
        }
    }, [viewerFileStorageReducer])

    const changePageNumber = (event) => {
        setLoading(false);
        console.warn("newpage", event.target.value);
        if (parseInt(event.target.value) <= totalPage && parseInt(event.target.value) >= 0) {
            setPageFind(event.target.value);
            console.log("*******");
            setCurrentPage(parseInt(event.target.value - 1));
            setTempVal(parseInt(event.target.value));
            dispatch(ViewerFileStorage(id, event.target.value - 1));

        }
    }

    const print = (event) => {
        event.preventDefault();
        dispatch(PrintPDFFiles(id));

    }

    const downloadFile = (event) => {
        event.preventDefault();
        dispatch(DownloadFilesAction(id));

        /*
        var link = document.createElement("a");
        link.download = viewerReducer.data.data.name;
        link.href = viewerFileStorageReducer.data.data;
        link.click();
        */
    }


    var image_cache = {};
    var image_width = 0;
    var image_height = 0;

    //var isZoom = false;
    const ToPage = (toPage, isZoom, callback) => {
        //isLoading = true;

        //$('#loadingDiv').animate({ opacity: 0.5 }, 50);
        console.log("going page", toPage);
        var img = new Image();
        img.onerror = function () {
            console.log(arguments);
        }

        img.onload = function () {
            var canvas = $('#canvas');

            if (canvas.length > 0) {

                var ctx = canvas[0].getContext('2d');
                //canvas.width(document.getElementById('root').clientWidth - 300);
                //canvas.height(window.innerHeight - 300);

                /// conversion factor for scale, we want 300 DPI in this example
                var dpiFactor = 300 / 96,
                    width = 400,
                    height = 100;

                /// set canvas size representing 300 DPI
                canvas.width(width * dpiFactor);
                canvas.height(height * dpiFactor);


                ctx.width = canvas.width();
                ctx.height = canvas.height();
                canvas.attr("width", canvas.width());
                canvas.attr("height", canvas.height());
                console.log("onLoad", img.width, img.height);

                var rv = downScaleImage(img, ctx);
                rv.className = "cvpg";
                rv.id = "cvpg";
                $('.cvpg').remove();

                document.getElementsByClassName("canvasp")[0].appendChild(rv);
                image_cache[toPage] = getDataUrl(img);

                $('#loadingDiv').animate({ opacity: 0 }, 250);

                if (callback) callback();

                isLoading = false;
                setLoading(true);
            }
        }

        if (viewerFileStorageReducer && viewerFileStorageReducer.data) {
            img.src = viewerFileStorageReducer.data.data;
            if (!streamFlag) {
                //document.getElementById("canvas").appendChild(img);
                setStreamFlag(true);
            }

        }

        //if (image_cache[toPage]) {
        //
        //img.src = image_cache[toPage];
        //} else {
        //img.src = viewerFileStorageReducer;
        //"../Page/@Model.ID?PageID=" + toPage; 
        //}

        image_width = img.width;
        image_height = img.height;


        //document.getElementById("pageNumber").value = 1 + currentPage;

    }

    var isLoading = false;

    window.onload = function () {
        $('.navbar').mouseenter(function () { $('.navbar').css("opacity", 1); });
        $('.navbar').mouseleave(function () { $('.navbar').css("opacity", 0); });
    }

    function fullScreenMode() {
        var elem = document.getElementsByClassName("canvasp")[0];
        //elem.style.width = "100vw";  // Tam genişlik
        //elem.style.height = "100vh"; // Tam yükseklik
        //cvpg.style.width = "100vw"; 
        //cvpg.style.height = "100vh"; 
        if (elem) {
            let userAgent = navigator.userAgent;

            if (userAgent.match(/chrome|chromium|crios/i)) {
                elem.requestFullscreen();
            } else if (userAgent.match(/safari/i)) {
                elem.webkitRequestFullscreen();
            } else if (userAgent.match(/edg/i)) {
                elem.msRequestFullscreen();
            }
        }
    }

    var flowTime = 10000;
    var flowInterval;
    var flowInterval2;
    var flowBg = "";
    var cw = 0;

    function inFlow() {
        var t = cw += 2;
        $('#roadp').css("width", t + "%");
    }

    /*function Flow() {
        if (flowInterval) {
            clearInterval(flowInterval);
            clearInterval(flowInterval2);
            flowInterval = undefined;
            flowInterval2 = undefined;
            flowTime = 10000;
            $('#roadshow').css("background-color", flowBg);
            $('#roadp').css("width", "0%");
        }
        else {
            flowInterval2 = setInterval(inFlow, flowTime / 50);
            flowBg = $('#roadshow').css("background-color");
            $('#roadshow').css("background-color", "yellow");
            flowInterval = setInterval(() => {

                if (flowInterval2)
                    clearInterval(flowInterval2);

                if (currentPage == pages) {
                    Flow();
                } else {
                    ToPage(currentPage + 1, () => { flowInterval2 = setInterval(inFlow, flowTime / 50); });
                    cw = 0;
                }
            }, flowTime);

        }
    }*/

    function scaleSelectChange() {
        debugger;
        var vc = $('#scaleSelect')[0].value;

        if (vc === "auto") {
            ratioRef.current = document.getElementById('root').clientWidth / image_width;
            changeRatio((ratioRef.current / 100.0) * 90.0);
        }
        else if (vc === "page-actual") {
            ratioRef.current = 1;
            changeRatio(ratioRef.current);
        }
        else if (vc === "page-fit") {
            ratioRef.current = Math.min(document.getElementById('root').clientWidth / image_width, window.screen.height / image_height);
            changeRatio(ratioRef.current);
        }
        else if (vc === "page-width") {
            ratioRef.current = document.getElementById('root').clientWidth / image_width;
            changeRatio(ratioRef.current);
        }
        else if (!isNaN(parseFloat(vc))) {
            ratioRef.current = parseFloat(vc);
            changeRatio(parseFloat(vc))
        }
    }


    useEffect(() => {
        const updateKeyDown = (e) => {
            e.preventDefault(); // prevent the default action (scroll / move caret)
            if (isLoading) return;

            console.log("which", e.which, "*****")
            switch (e.which) {
                case 37: // left
                    /*if (cpRef.current >= 1) {
                        var ct = cpRef.current - 1;
                        setLoading(false);
                        dispatch(ViewerFileStorage(id, ct));                    
                        setCurrentPage(ct);      
                        setPageFind(String(ct + 1));   
                        
                    }*/
                    break;

                case 38: // up
                    if (cpRef.current >= 1) {
                        var ct = cpRef.current - 1;
                        setLoading(false);
                        dispatch(ViewerFileStorage(id, ct));
                        setCurrentPage(ct);
                        setPageFind(String(ct + 1));

                    }
                    break;

                case 39: // right
                    /*if (cpRef.current < PagesRef.current - 1) {
                            var ct = cpRef.current + 1;
                            setLoading(false);
                            dispatch(ViewerFileStorage(id, ct));
                            setCurrentPage(ct);      
                            setPageFind(String(ct + 1));    
                        }*/
                    break;

                case 40: // down
                    if (cpRef.current < PagesRef.current - 1) {
                        var ct = cpRef.current + 1;
                        setLoading(false);
                        dispatch(ViewerFileStorage(id, ct));
                        setCurrentPage(ct);
                        setPageFind(String(ct + 1));
                    }
                    //location.href = '../';
                    break;

                default: return; // exit this handler for other keys
            }

        };

        window.addEventListener('keydown', updateKeyDown);
        console.log('subscribed to wheelEvent')
        return function () {
            window.removeEventListener('keydown', updateKeyDown);
        }
    }, []);

    const wtimer = useRef();

    const PreviousPageEvent = () => {
        if (cpRef.current < PagesRef.current - 1) {
            var ct = cpRef.current + 1;
            setLoading(false);
            dispatch(ViewerFileStorage(id, ct));
            setCurrentPage(ct);
            setPageFind(String(ct + 1));
        }
    }

    const AfterPageEvent = () => {
        if (cpRef.current >= 1) {
            var ct = cpRef.current - 1;
            setLoading(false);
            dispatch(ViewerFileStorage(id, ct));
            setCurrentPage(ct);
            setPageFind(String(ct + 1));

        }
    }
    useEffect(() => {


        const updateScroll = (e) => {

            const tp = PagesRef.current;
            console.log("***", tp);
            if (!!e.deltaY) {
                var element = document.getElementById("pagesrc");
                var scrollHeight = element.scrollHeight;
                var wheight = document.getElementById("pagesrc").clientHeight
                var scroll = Math.floor(document.getElementById("pagesrc").scrollTop);

                if (e.deltaY < 0) {
                    var cpos = scrollHeight - (scroll + wheight);
                    if (scroll == 0 || scroll == 1) {
                        clearTimeout(wtimer.current);
                        wtimer.current = setTimeout(() => {

                            const vt = cpRef.current - 1;
                            if (vt >= 0) {
                                setLoading(false);
                                dispatch(ViewerFileStorage(id, vt));
                                setCurrentPage(vt);
                                setPageFind(String(vt + 1));
                                setTest(testRef.current - 1);
                            }
                        }, 250);
                    }
                }
                else {
                    var cpos = scrollHeight - (scroll + wheight);
                    if (cpos == 0 || cpos == 1) {
                        clearTimeout(wtimer.current);
                        wtimer.current = setTimeout(() => {
                            const vt = 1 + cpRef.current;
                            if (vt < tp) {
                                setLoading(false);
                                dispatch(ViewerFileStorage(id, vt));
                                setCurrentPage(vt);
                                setPageFind(String(vt + 1));
                                setTest(testRef.current + 1);
                            }

                        }, 250);
                    }
                }
            }
            else {
                console.log('zero', e.deltaY);
            }

        };


        window.addEventListener('mousewheel', updateScroll);
        console.log('subscribed to wheelEvent')
        return function () {
            window.removeEventListener('mousewheel', updateScroll);
        }
    }, []);

    function getDataUrl(img) {
        // Create canvas
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        // Set width and height
        canvas.width = img.width;
        canvas.height = img.height;
        // Draw the image
        ctx.drawImage(img, 0, 0);
        return canvas.toDataURL('image/jpeg');
    }

    function zoomIn() {
        $('#scaleSelect')[0].value = "";
        ratioRef.current += 0.1;
        changeRatio(ratioRef.current);
    }
    function zoomOut() {
        $('#scaleSelect')[0].value = "";
        ratioRef.current -= 0.1;
        changeRatio(ratioRef.current);
    }

    function changeRatio(newRatio) {//newratio
        console.log("new ratio is", newRatio);
        if (newRatio && newRatio > 0 && newRatio < 10) {
            document.getElementById("change_ratio").value = newRatio;
        }


        ToPage(currentPage);
    }


    function drawImageScaled(img, ctx) {
        var canvas = ctx.canvas;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        var hRatio = canvas.width / img.width;
        var vRatio = canvas.height / img.height;
        var ratio = Math.min(hRatio, vRatio);
        if (ratio > 1) ratio = 1;
        ratioRef.current = ratioRef.current * ratioRef.current;
        var centerShift_x = (canvas.width - img.width * ratio) / 2;
        var centerShift_y = (canvas.height - img.height * ratio) / 2;
        ctx.imageSmoothingEnabled = false;
        console.log("ratio", ratio, "width", img.width, "height", img.height, "center x", centerShift_x, "center y", centerShift_y, "ratiodwidth", img.width * ratio, "ratiodheight", img.height * ratio);

        ctx.drawImage(img, 0, 0, img.width, img.height, centerShift_x, centerShift_y, img.width * ratio, img.height * ratio);
    }

    function openFullscreen(elem) {
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) { /* Safari */
            elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE11 */
            elem.msRequestFullscreen();
        }
    }


    // scales the image by (float) scale < 1
    // returns a canvas containing the scaled image.
    function downScaleImage(img, ctx) {
        var vc = $('#scaleSelect')[0].value;
        if (vc === "auto" || vc === "page-width") {
            ratioRef.current = (document.getElementById('root').clientWidth / img.width) * 0.9;
        }
        else if (vc === "page-actual") {
            ratioRef.current = 1;
        }
        else if (vc === "page-fit") {
            ratioRef.current = Math.min(document.getElementById('root').clientWidth / img.width, window.screen.height / img.height) * 0.9;
        }
        var scale = 1 * ratioRef.current;
        var imgCV = document.createElement('canvas');
        console.log("current scale", scale);
        if (scale < 1) {
            imgCV.width = img.width;
            imgCV.height = img.height;
            var imgCtx = imgCV.getContext('2d');
            imgCtx.drawImage(img, 0, 0);
            const t = downScaleCanvas(imgCV, scale);
            console.log("dscl", "iw", img.width, "ih", img.height, "tw", t.width, "th", t.height, "sc", scale)
            return t;
        }
        else {
            imgCV.width = img.width * scale;
            imgCV.height = img.height * scale;
            var imgCtx = imgCV.getContext('2d');
            imgCtx.scale(scale, scale);
            imgCtx.drawImage(img, 0, 0,);
            return imgCV;
        }
    }

    // scales the canvas by (float) scale < 1
    // returns a new canvas containing the scaled image.
    function downScaleCanvas(cv, scale) {

        if (!(scale < 1) || !(scale > 0)) throw ('scale must be a positive number <1 ');
        var sqScale = scale * scale; // square scale = area of source pixel within target
        var sw = cv.width; // source image width
        var sh = cv.height; // source image height
        var tw = Math.floor(sw * scale); // target image width
        var th = Math.floor(sh * scale); // target image height
        var sx = 0, sy = 0, sIndex = 0; // source x,y, index within source array
        var tx = 0, ty = 0, yIndex = 0, tIndex = 0; // target x,y, x,y index within target array
        var tX = 0, tY = 0; // rounded tx, ty
        var w = 0, nw = 0, wx = 0, nwx = 0, wy = 0, nwy = 0; // weight / next weight x / y
        // weight is weight of current source point within target.
        // next weight is weight of current source point within next target's point.
        var crossX = false; // does scaled px cross its current px right border ?
        var crossY = false; // does scaled px cross its current px bottom border ?
        var sBuffer = cv.getContext('2d').
            getImageData(0, 0, sw, sh).data; // source buffer 8 bit rgba
        var tBuffer = new Float32Array(3 * tw * th); // target buffer Float32 rgb
        var sR = 0, sG = 0, sB = 0; // source's current point r,g,b
        /* untested !
        var sA = 0;  //source alpha  */

        for (sy = 0; sy < sh; sy++) {
            ty = sy * scale; // y src position within target
            tY = 0 | ty;     // rounded : target pixel's y
            yIndex = 3 * tY * tw;  // line index within target array
            crossY = (tY != (0 | ty + scale));
            if (crossY) { // if pixel is crossing botton target pixel
                wy = (tY + 1 - ty); // weight of point within target pixel
                nwy = (ty + scale - tY - 1); // ... within y+1 target pixel
            }
            for (sx = 0; sx < sw; sx++, sIndex += 4) {
                tx = sx * scale; // x src position within target
                tX = 0 | tx;    // rounded : target pixel's x
                tIndex = yIndex + tX * 3; // target pixel index within target array
                crossX = (tX != (0 | tx + scale));
                if (crossX) { // if pixel is crossing target pixel's right
                    wx = (tX + 1 - tx); // weight of point within target pixel
                    nwx = (tx + scale - tX - 1); // ... within x+1 target pixel
                }
                sR = sBuffer[sIndex];   // retrieving r,g,b for curr src px.
                sG = sBuffer[sIndex + 1];
                sB = sBuffer[sIndex + 2];

                /* !! untested : handling alpha !!
                   sA = sBuffer[sIndex + 3];
                   if (!sA) continue;
                   if (sA != 0xFF) {
                       sR = (sR * sA) >> 8;  // or use /256 instead ??
                       sG = (sG * sA) >> 8;
                       sB = (sB * sA) >> 8;
                   }
                */
                if (!crossX && !crossY) { // pixel does not cross
                    // just add components weighted by squared scale.
                    tBuffer[tIndex] += sR * sqScale;
                    tBuffer[tIndex + 1] += sG * sqScale;
                    tBuffer[tIndex + 2] += sB * sqScale;
                } else if (crossX && !crossY) { // cross on X only
                    w = wx * scale;
                    // add weighted component for current px
                    tBuffer[tIndex] += sR * w;
                    tBuffer[tIndex + 1] += sG * w;
                    tBuffer[tIndex + 2] += sB * w;
                    // add weighted component for next (tX+1) px                
                    nw = nwx * scale
                    tBuffer[tIndex + 3] += sR * nw;
                    tBuffer[tIndex + 4] += sG * nw;
                    tBuffer[tIndex + 5] += sB * nw;
                } else if (crossY && !crossX) { // cross on Y only
                    w = wy * scale;
                    // add weighted component for current px
                    tBuffer[tIndex] += sR * w;
                    tBuffer[tIndex + 1] += sG * w;
                    tBuffer[tIndex + 2] += sB * w;
                    // add weighted component for next (tY+1) px                
                    nw = nwy * scale
                    tBuffer[tIndex + 3 * tw] += sR * nw;
                    tBuffer[tIndex + 3 * tw + 1] += sG * nw;
                    tBuffer[tIndex + 3 * tw + 2] += sB * nw;
                } else { // crosses both x and y : four target points involved
                    // add weighted component for current px
                    w = wx * wy;
                    tBuffer[tIndex] += sR * w;
                    tBuffer[tIndex + 1] += sG * w;
                    tBuffer[tIndex + 2] += sB * w;
                    // for tX + 1; tY px
                    nw = nwx * wy;
                    tBuffer[tIndex + 3] += sR * nw;
                    tBuffer[tIndex + 4] += sG * nw;
                    tBuffer[tIndex + 5] += sB * nw;
                    // for tX ; tY + 1 px
                    nw = wx * nwy;
                    tBuffer[tIndex + 3 * tw] += sR * nw;
                    tBuffer[tIndex + 3 * tw + 1] += sG * nw;
                    tBuffer[tIndex + 3 * tw + 2] += sB * nw;
                    // for tX + 1 ; tY +1 px
                    nw = nwx * nwy;
                    tBuffer[tIndex + 3 * tw + 3] += sR * nw;
                    tBuffer[tIndex + 3 * tw + 4] += sG * nw;
                    tBuffer[tIndex + 3 * tw + 5] += sB * nw;
                }
            } // end for sx 
        } // end for sy

        // create result canvas
        var resCV = document.createElement('canvas');
        resCV.width = tw;
        resCV.height = th;
        var resCtx = resCV.getContext('2d');
        var imgRes = resCtx.getImageData(0, 0, tw, th);
        var tByteBuffer = imgRes.data;
        // convert float32 array into a UInt8Clamped Array
        var pxIndex = 0; //  
        for (sIndex = 0, tIndex = 0; pxIndex < tw * th; sIndex += 3, tIndex += 4, pxIndex++) {
            tByteBuffer[tIndex] = Math.ceil(tBuffer[sIndex]);
            tByteBuffer[tIndex + 1] = Math.ceil(tBuffer[sIndex + 1]);
            tByteBuffer[tIndex + 2] = Math.ceil(tBuffer[sIndex + 2]);
            tByteBuffer[tIndex + 3] = 255;
        }
        // writing result to canvas.
        resCtx.putImageData(imgRes, 0, 0);
        return resCV;
    }

    window.onresize = function () {
        $('#btns').css("bottom", (-1 * $(window).scrollTop()) + "px");
    }
    window.onscroll = function () {
        $('#btns').css("bottom", (-1 * $(window).scrollTop()) + "px");
    }

    //'use strict'; var _extends = Object.assign || function (a) { for (var b, c = 1; c < arguments.length; c++)for (var d in b = arguments[c], b) Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]); return a }, SwipeListener = function (a, b) { if (a) { 'undefined' != typeof window && function () { function a(a, b) { b = b || { bubbles: !1, cancelable: !1, detail: void 0 }; var c = document.createEvent('CustomEvent'); return c.initCustomEvent(a, b.bubbles, b.cancelable, b.detail), c } return 'function' != typeof window.CustomEvent && void (a.prototype = window.Event.prototype, window.CustomEvent = a) }(); b || (b = {}), b = _extends({}, { minHorizontal: 10, minVertical: 10, deltaHorizontal: 3, deltaVertical: 5, preventScroll: !1, lockAxis: !0, touch: !0, mouse: !0 }, b); var c = [], d = !1, e = function () { d = !0 }, f = function (a) { d = !1, h(a) }, g = function (a) { d && (a.changedTouches = [{ clientX: a.clientX, clientY: a.clientY }], i(a)) }; b.mouse && (a.addEventListener('mousedown', e), a.addEventListener('mouseup', f), a.addEventListener('mousemove', g)); var h = function (d) { var e = Math.abs, f = Math.max, g = Math.min; if (c.length) { for (var h = 'function' == typeof TouchEvent && d instanceof TouchEvent, j = [], k = [], l = { top: !1, right: !1, bottom: !1, left: !1 }, m = 0; m < c.length; m++)j.push(c[m].x), k.push(c[m].y); var i = j[0], n = j[j.length - 1], o = k[0], p = k[k.length - 1], q = { x: [i, n], y: [o, p] }; if (1 < c.length) { var r = { detail: _extends({ touch: h, target: d.target }, q) }, s = new CustomEvent('swiperelease', r); a.dispatchEvent(s) } var t = j[0] - j[j.length - 1], u = 'none'; u = 0 < t ? 'left' : 'right'; var v, w = g.apply(Math, j), x = f.apply(Math, j); if (e(t) >= b.minHorizontal && ('left' == u ? (v = e(w - j[j.length - 1]), v <= b.deltaHorizontal && (l.left = !0)) : 'right' == u ? (v = e(x - j[j.length - 1]), v <= b.deltaHorizontal && (l.right = !0)) : void 0), t = k[0] - k[k.length - 1], u = 'none', u = 0 < t ? 'top' : 'bottom', w = g.apply(Math, k), x = f.apply(Math, k), e(t) >= b.minVertical && ('top' == u ? (v = e(w - k[k.length - 1]), v <= b.deltaVertical && (l.top = !0)) : 'bottom' == u ? (v = e(x - k[k.length - 1]), v <= b.deltaVertical && (l.bottom = !0)) : void 0), (c = [], l.top || l.right || l.bottom || l.left)) { b.lockAxis && ((l.left || l.right) && e(i - n) > e(o - p) ? l.top = l.bottom = !1 : (l.top || l.bottom) && e(i - n) < e(o - p) && (l.left = l.right = !1)); var y = { detail: _extends({ directions: l, touch: h, target: d.target }, q) }, z = new CustomEvent('swipe', y); a.dispatchEvent(z) } else { var A = new CustomEvent('swipecancel', { detail: _extends({ touch: h, target: d.target }, q) }); a.dispatchEvent(A) } } }, i = function (d) { var e = d.changedTouches[0]; if (c.push({ x: e.clientX, y: e.clientY }), 1 < c.length) { var f = c[0].x, g = c[c.length - 1].x, h = c[0].y, i = c[c.length - 1].y, j = { detail: { x: [f, g], y: [h, i], touch: 'function' == typeof TouchEvent && d instanceof TouchEvent, target: d.target } }, k = new CustomEvent('swiping', j), l = !0 === b.preventScroll || 'function' == typeof b.preventScroll && b.preventScroll(k); l && d.preventDefault(), a.dispatchEvent(k) } }, j = !1; try { var k = Object.defineProperty({}, 'passive', { get: function () { j = { passive: !b.preventScroll } } }); window.addEventListener('testPassive', null, k), window.removeEventListener('testPassive', null, k) } catch (a) { } return b.touch && (a.addEventListener('touchmove', i, j), a.addEventListener('touchend', h)), { off: function () { a.removeEventListener('touchmove', i, j), a.removeEventListener('touchend', h), a.removeEventListener('mousedown', e), a.removeEventListener('mouseup', f), a.removeEventListener('mousemove', g) } } } }; 'undefined' != typeof module && 'undefined' != typeof module.exports ? (module.exports = SwipeListener, module.exports.default = SwipeListener) : 'function' == typeof define && define.amd ? define([], function () { return SwipeListener }) : window.SwipeListener = SwipeListener;


    let setMessage = function (msg) {
        console.log(msg);
    }
    const container = document.getElementById("sw");
    //var listener = SwipeListener(container);

    /* container.addEventListener('swipe', function (e) {
 
         var d = e.detail.directions;
 
         if (d.top) {
             if (d.right) {
                 setMessage('Swiped top-right.');
             } else if (d.left) {
                 setMessage('Swiped top-left.');
             } else {
                 setMessage('Swiped top.');
             }
         } else if (d.bottom) {
             if (d.right) {
                 setMessage('Swiped bottom-right.');
             } else if (d.left) {
                 setMessage('Swiped bottom-left.');
             } else {
                 setMessage('Swiped bottom.');
             }
         } else {
             if (d.right) {
                 setMessage('Swiped right.');
                 if (currentPage > 0)
                     ToPage(currentPage - 1)
             } else if (d.left) {
                 setMessage('Swiped left.');
                 if (currentPage < pages - 1)
                     ToPage(currentPage + 1)
             }
         }
     });
 
     container.addEventListener('swiping', function (e) {
         console.log('swiping', e.detail);
     });
 
     container.addEventListener('swiperelease', function (e) {
         console.log('swiperelease', e.detail);
     });
 
     container.addEventListener('swipecancel', function (e) {
         console.log('swipecancel', e.detail);
     });
     */

    /*document.getElementById("pageNumber").addEventListener("change", function (e) {
        var tv = parseInt(e.target.value);
        if (tv - 1 >= 0)
            if (tv - 1 < pages)
                ToPage(tv - 1);
    });
    */

    const [sidebarVisibility, setSidebarVisiblity] = useState(true);
    const changeSidebarVisibility = (event) => {
        event.preventDefault();
        var element = document.getElementById('toolbarViewer');
        if (sidebarVisibility === true) {

            element.style.marginTop = "-200px";
        } else {
            element.style.marginTop = null;
        }
        setSidebarVisiblity(!sidebarVisibility);
    }
    //<img src={booby} alt="brand" width={85} height={40}></img>

    const [flg, setFlg] = useState(false);

    const sendReport = (event) => {
        event.preventDefault();
        dispatch(SendReportEmail(JSON.parse(localStorage.user).id, id));
    }

    useEffect(() => {
        if (flg && totalPage !== 1) {
            setFlg(false);
            var min = 1,
                max = totalPage,
                select = document.getElementById('pageNumber');
            document.getElementById('pageNumber').querySelectorAll('option').forEach(el => el.remove());
            for (var i = min; i <= max; i++) {
                var opt = document.createElement('option');
                opt.value = i;
                opt.innerHTML = i;
                select.appendChild(opt);
            }
        }
    }, [totalPage])

    return (

        <>
            {
                !loading && <SplashScreen />
            }
            <ToastContainer />
            <div id="roadp" className={viewerFileStorageReducer.fetching ? 'roadpshow' : ''} style={{ height: '1px', position: 'absolute', zIndex: '105', backgroundColor: 'black' }}></div>
            {!sidebarVisibility && <div className="m-3" style={{ right: '0', position: 'absolute', zIndex: '9999' }}>
                <i className="fa-solid fa-thumbtack fa-rotate-90" onClick={changeSidebarVisibility}></i>
            </div>}
            <div className="toolbar">
                <div id="toolbarContainer">
                    <div id="toolbarViewer" className="d-flex p-2">
                        <div id="toolbarViewerLeft" className="d-flex">
                            <Link to="/index" className="text-decoration-none" style={{ color: 'inherit', textAlign: 'center' }}>
                                <img id="bymmyImage" src={boobyR} alt="Bymmy App"></img>
                            </Link>
                            <div className="pipe" />
                            <select title="Page" onChange={changePageNumber} value={pagefind} className="toolbarField text-center" id="pageNumber" tabIndex="23" data-l10n-id="zoom" ></select>
                            <span id="numPages" className="text-center " title="Page" value={totalPage} size="4">&nbsp;of {totalPage}</span>
                            <div className="pipe" />
                            <div className="splitToolbarButton d-flex" >
                                <div id="zoomOut" onClick={zoomOut} title="Zoom Out">
                                    <Minus size={24} />
                                </div>
                                <div className="splitToolbarButtonSeparator"></div>

                                <div id="zoomIn" onClick={zoomIn} title="Zoom In">
                                    <Plus size={24} />
                                </div>
                                <div className="pipe" />
                            </div>
                            <span id="scaleSelectContainer" className="dropdownToolbarButton rounded" onChange={scaleSelectChange}>
                                <select id="scaleSelect" title="Zoom" tabIndex="23" defaultValue={'page-fit'} data-l10n-id="zoom" style={{ fontSize: '0.71rem' }}>
                                    <option id="pageAutoOption" title="" value="auto" >Auto Zoom</option>
                                    <option id="pageActualOption" title="" value="page-actual">Actual Size</option>
                                    <option id="pageFitOption" title="" value="page-fit">Page Fit</option>
                                    <option id="pageWidthOption" title="" value="page-width" >Page Width</option>
                                    <option title="" value="0.5" data-l10n-id="page_scale_percent" >50%</option>
                                    <option title="" value="0.75" data-l10n-id="page_scale_percent" >75%</option>
                                    <option title="" value="1" data-l10n-id="page_scale_percent" >100%</option>
                                    <option title="" value="1.25" data-l10n-id="page_scale_percent">125%</option>
                                    <option title="" value="1.5" data-l10n-id="page_scale_percent" >150%</option>
                                    <option title="" value="2" data-l10n-id="page_scale_percent" >200%</option>
                                    <option title="" value="3" data-l10n-id="page_scale_percent" >300%</option>
                                    <option title="" value="4" data-l10n-id="page_scale_percent" >400%</option>
                                </select>
                            </span>
                        </div>

                        <div id="toolbarViewerMiddle" className="d-flex">
                        </div>

                        <div id="toolbarViewerMiddle-2" className="d-flex" style={{ margin: 'auto' }}>
                        </div>

                        <div id="toolbarViewerRight" className="d-flex" style={{ marginLeft: 'auto' }}>
                            <div className="pipe"></div>
                            <div title="Presentation Mode" id="presentationMode" onClick={fullScreenMode} >
                                <Presentation size={24} />
                            </div>
                            <div className="pipe" />
                            <>
                                {isAllowedDownload ?
                                    <>
                                        <div id="print" className="hiddenMediumView" onClick={print} title="Print" tabIndex="33" >
                                            <Printer size={24} />
                                        </div>
                                        <div className="pipe" />
                                        <div id="download" className="hiddenMediumView" onClick={downloadFile} title="Download" tabIndex="34" data-l10n-id="download">
                                            <Download size={24} />
                                        </div>
                                        <div className="pipe" />
                                    </>
                                    : <></>

                                }
                            </>
                            <div title="Flag Content" id="ReportDocument" onClick={sendReport} >
                                <Megaphone size={24} />
                            </div>
                            <div className="verticalToolbarSeparator hiddenSmallView"></div>


                        </div>


                    </div>
                    <div id="loadingBar" className="hidden">
                        <div className="progress" style={{ height: '100%', width: '100%' }} >
                            <div className="glimmer">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {permission === true ?
                <div style={{ width: '100%', height: '100%', position: 'absolute', top: '100px', left: '0', overflow: 'auto' }} id="pagesrc" className="viewer">
                    <div className="canvasp" ><canvas id="canvas"></canvas></div>
                    <div className="leftLongIcon">
                        <div className="lftLoB" onClick={AfterPageEvent}>
                            <WestIcon width="45px" />
                        </div>
                    </div>
                    <div className="leftRightIcon">
                        <div className="lftLoB" onClick={PreviousPageEvent}>
                            <EastIcon width="45px" />
                        </div>
                    </div>
                </div>
                :
                <div className="alert alert-danger d-flex align-items-center fw-bold m-2" role="alert">
                    <i className="fa fa-solid fa-triangle-exclamation"></i>
                    {errorMessage !== "" ?
                        <div>
                            &nbsp;{errorMessage}
                        </div>
                        :
                        <div>
                            &nbsp;You Don't Have Permission for Showing PDF
                        </div>
                    }
                </div>
            }
            <input style={{ display: 'none' }} type="text" onChange={changeRatio} id="change_ratio" />

        </>
    )
}
/*
<Spinner animation="border" variant="info" />
 <button id="FindAscendingPageNumber" className="toolbarButton hidden rounded" onClick={clickPageNumberFindDesc} title="Next Page" tabIndex="12">
                                <i className="fa fa-arrow-left"></i>
                            </button>
                            <button id="FindDescendingPageNumber" className="toolbarButton hidden rounded" onClick={clickPageNumberFindAsc} title="Previous Page" tabIndex="13">
                                <i className="fa fa-arrow-right"></i>
                            </button>


                            */

//<div id="loadingDiv"><div className="loader">Loading...</div></div>
/*
                        <button id="secondaryToolbarToggle" className="toolbarButton rounded"  title="Tools" tabIndex="36" data-l10n-id="tools" aria-expanded="false" aria-controls="secondaryToolbar">
                            <span><i className="fa fa-cogs"></i>&nbsp;Tools</span>
                        </button>
                        */




/*window.onLoad = () => {
    ToPage(0);
    $('.navbar').mouseenter(function () { $('.navbar').css("opacity", 1); });
    $('.navbar').mouseleave(function () { $('.navbar').css("opacity", 0); });
}*/



/*
 <div className="splitToolbarButton hiddenSmallView">
                        <button className="toolbarButton" title="Previous Page" id="previous" tabIndex="13" onClick={ToPage(currentPage-1)}>
                        <span data-l10n-id="previous_label" className="fa fa-arrow-up">P</span>
                        </button>
                        <div className="splitToolbarButtonSeparator"></div>
                                    <button className="toolbarButton" title="Next Page" id="next" tabIndex="14" onClick={ToPage(currentPage + 1)}>
                        <span data-l10n-id="next_label" className="fa fa-arrow-down">N</span>
                        </button>
                    </div>
                    */








